import "../scss/app.scss";
import Vue from "vue";
import "bootstrap";
const carousels = require("./carousels");
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const app = new Vue({
  el: "#app",
  data: {
    isToggleMenu: false,
    isScrolled: false,
  },
  mounted() {
    this.InView();
    carousels.carouselSingle();
    carousels.carouselSingleThumbnail();
    carousels.carouselCentering();
    carousels.carouselSideScrolling();
    carousels.carouselCover();
  },
  methods: {
    InView() {
      const trigger = document.querySelectorAll("[data-trigger]");
      trigger.forEach(function (userItem) {
        ScrollTrigger.create({
          trigger: userItem,
          start: "top bottom-=50px",
          end: "bottom top+=50px",
          toggleClass: { targets: userItem, className: "InView" },
          once: true,
        });
      });
    },
  },
  directives: {
    "scroll-class": {
      inserted(el, binding, vnode) {
        const className = binding.arg || "scrolled";
        const scrollHandler = () => {
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const threshold = parseInt(binding.value) || 1;
          const isAdd = scrollTop >= threshold;
          el.classList.toggle(className, isAdd);
          vnode.context.isScrolled = isAdd;
        };
        window.addEventListener("scroll", scrollHandler);
        scrollHandler();
      },
    },
  },
});

// faqのアコーディオン
document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".accordion-header");

  headers.forEach((header) => {
    header.addEventListener("click", function (e) {
      e.stopPropagation();

      const contentId = this.getAttribute("data-target");
      const targetContent = document.getElementById(contentId);
      const button = this.querySelector(".accordion-button"); // ボタン取得
      const isActive = this.classList.contains("active");

      if (isActive) {
        // 開いている → 閉じる
        this.classList.remove("active");
        button.classList.remove("active");
        targetContent.classList.remove("active");

        // アニメーションで閉じる
        targetContent.style.maxHeight = targetContent.scrollHeight + "px"; // 一旦現在の高さをセット
        requestAnimationFrame(() => {
          targetContent.style.maxHeight = "0px";
        });
      } else {
        // 開じている→ 開く
        this.classList.add("active");
        button.classList.add("active");
        targetContent.classList.add("active");

        // アニメーションで開く
        targetContent.style.maxHeight = targetContent.scrollHeight + "px";
      }
    });
  });
});

// faqのタブ
document.querySelectorAll(".tab-button").forEach((tab) => {
  tab.addEventListener("click", () => {
    const tabId = tab.dataset.tab;

    // 全タブの active を外す
    document.querySelectorAll(".tab-button").forEach((t) => {
      t.classList.remove("active");
      const path = t.querySelector("svg path");
      if (path) path.setAttribute("stroke", "#757575"); // 非選択時の色
    });

    // クリックしたタブを active に
    tab.classList.add("active");
    const path = tab.querySelector("svg path");
    if (path) path.setAttribute("stroke", "#0E71BA"); // 選択時の色

    // コンテンツ切り替え
    document.querySelectorAll(".tab-content").forEach((content) => {
      content.classList.remove("active");
    });
    const targetContent = document.getElementById(tabId);
    if (targetContent) targetContent.classList.add("active");
  });
});

//footer
document.addEventListener("DOMContentLoaded", function () {
  const submenu = document.getElementById("submenu-service");
  const toggleBtn = document.querySelector(".toggle-btn");

  submenu.addEventListener("show.bs.collapse", function () {
    toggleBtn.textContent = "－";
  });
  submenu.addEventListener("hide.bs.collapse", function () {
    toggleBtn.textContent = "＋";
  });
});
